<template>
  <div  v-if="this.type == 'widget'" class="passengers--main-wrapper">
    <div v-if="prevPassengerId" class="passenger-arrow prev-passenger" @click="prevPassenger"><i class="fa fa-angle-left"></i></div>
    <div class="passengers--wrapper">
      <div id="passengers">
        <div class="single--passenger" :id="`passenger_${passenger.id}`"
        :style="{
          '--passengerSelectedColor': style.passengerSelectedColor,
          '--passengerSelectedFontColor': style.passengerSelectedFontColor,
          '--fontColor1': style.fontColor1,
          '--fontColor2': style.fontColor2,
          '--seatSelectedColor': style.seatSelectedColor,
          '--fontFamily': style.fontFamily
        }"
        @click="handleSelection(passenger.id)" :class="(passengerId == passenger.id) ? 'active' : ''" v-for="passenger in passengersWithoutInfants" :key="passenger.id">
          <i v-if="passenger.seat.designator" class="fas fa-check-circle"></i>
          <i v-else class="base-icon-user icon-user icon--filled" v-bind:class="{'passenger--with-infant': passenger.infant}"></i>
          <i v-if="passenger.infant"  class="base-icon-user passenger--with-infant fas fa-baby"></i>
          <div class="info">
            <span class="passenger--name">{{ passenger.name }}</span>
            <span v-if="passenger.seat.designator">
              <span v-if="locale == 'he' ||  locale == 'ar'">{{ passenger.seat.designator }} {{ text.seat }}</span>
              <span v-else>{{ text.seat }} {{ passenger.seat.designator }} </span>
            </span>
            <span v-else>{{ text.no_seat_selected }}</span>
          </div>
        </div>
      </div>
    </div>


    <div v-if="this.nextPassengerId" class="passenger-arrow next-passenger" @click="nextPassenger"><i class="fa fa-angle-right"></i></div>
  </div>


  <div v-else class="air--route-frame">
      <PassengersDropdown ref="passengersSelRef" :options="passengersWithoutInfants" :selected="passengerId" :placeholder="`Select Passenger`" :updater="handleSelection" />
  </div>
</template>
<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { mapGetters, mapState, mapActions } from 'vuex'
import PassengersDropdown from '../Lib/PassengersDropdown'


export default {
  components: {
    PassengersDropdown
  },
  props: ['type'],
  mounted () {
    if(this.type == 'widget'){
      var passengers = document.getElementById('passengers')
      var _this = this

            passengers.addEventListener('click', function (e) {
        _this.activatePassenger(e.target)
      })
    } 
  },

  computed: {
    ...mapGetters(['flight', 'style', 'text', 'nextPassengerId', 'prevPassengerId', 'locale']),
    ...mapState(['passengerId']),
    passengersWithoutInfants () {
      return this.flight.passengers.filter(passenger => {
        return passenger.type !== 'infant'
      })
      .map(passenger => {
        return {
          id: passenger.id,
          name: passenger.name,
          seat: {
            designator: passenger.seat.designator,
            price: passenger.seat.price
          },
          type: passenger.type
        }
      })
    }
  },

  watch: {
    passengerId (newId, oldId) {
      if(this.type == 'widget'){
        var el = document.getElementById('passenger_' + newId)
        this.activatePassenger(el)
      } else{
        this.$refs.passengersSelRef.updateSelectedOption(newId)
      }
    }
  },

  methods: {
    ...mapActions(['changePassenger']),
    handleSelection (passengerId) {
      this.changePassenger(passengerId)
    },

    nextPassenger () {
      this.changePassenger(this.nextPassengerId)
    },

    prevPassenger () {
      this.changePassenger(this.prevPassengerId)
    },

    activatePassenger (target) {
      if (target) {
        if (target.classList.contains('single--passenger')) {
          target.parentNode.scrollLeft = target.offsetLeft
        } else {
          target.parentNode.parentNode.scrollLeft = target.parentNode.offsetLeft
        }
      }
    }
  }
}
</script>
<style>
#ss-container .close--widget {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  z-index: 9;
}

#ss-container .air--route {
  width: 100%;
  font-size: 19px;
  font-weight: bold;
}

#ss-container .air--route-frame {
  display: flex;
  align-items: center;
  height: inherit;
  font-size: 19px;
  padding: 0;
  width: 50%;
}

#ss-container .passengers--main-wrapper {
  height: 60px !important;
  width: 100%;
  position: relative;
}
#ss-container .passengers--wrapper {
  overflow: hidden;
  height: 100%;
}
#ss-container #passengers {
  height: 75px !important;
  width: 100%;
  position: relative;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  /*display: flex;*/
}
/*#ss-container #passengers:before {
  position: fixed;
  content: '';
  right: 0;
  height: 75px;
  top: 50px;
  background-image: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.9) 100%);
  width: 150px;
  z-index: 2;
}*/
#ss-container .single--passenger {
  position: relative;
  width: 100%;
  max-width: 258px;
  height: 55px;
  border: 1px solid var(--fontColor1);
  padding: 0 0;
  border-radius: 2px;
  display: inline-flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  margin-right: 15px;
  font-family: var(--fontFamily);
}
#ss-container .single--passenger i.fa-check-circle {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  height: 100%;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: var(--seatSelectedColor);
}
#ss-container .single--passenger.active {
  background-color: var(--passengerSelectedFontColor);
  border-color: var(--passengerSelectedColor);
}
#ss-container .single--passenger i.base-icon-user {
  width: 50px;
  /*min-width: 50px;*/
  /*max-width: 50px;*/
  height: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: var(--fontColor1);
}
#ss-container .single--passenger.active i.base-icon-user,
#ss-container .single--passenger.active i.fa-check-circle {
  color: var(--passengerSelectedColor);
}
#ss-container .single--passenger .info .passenger--name {
  font-size: 16px;
  font-weight: bold;
  color: var(--fontColor1);
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  max-width: 195px;
}
#ss-container .single--passenger .info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: flex-start;
  align-items: flex-start;
  justify-content: center;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  font-size: 16px;
  font-weight: bold;
  color: var(--fontColor1);
  margin-right: 5px;
}
#ss-container .single--passenger .info span {
  font-size: 14px;
  margin-top: 3px;
  font-weight: 1;
  color: var(--fontColor1);
}
#ss-container .single--passenger.active .info {
  color: var(--passengerSelectedColor);
}
#ss-container .single--passenger.active .info span {
  color: var(--passengerSelectedColor);
}
/*Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) {
}
/*Large devices (desktops, 992px and up)*/
@media (min-width: 992px) {
}
/*Extra large devices (large desktops, 1200px and up)*/
@media (min-width: 1200px) {}

#ss-container .passenger--with-infant {
  width: 30px !important;
}
#ss-container .prev-passenger {
  left: -18px;
}
#ss-container .next-passenger {
  right: -18px;
}
#ss-container .passenger-arrow {
  position: absolute;
  z-index: 1;
  font-size: 24px;
  top: 14px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Passengers.vue